exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._1zB7H25cwT1ac2rN29vsLS{white-space:nowrap}html[dir] ._1zB7H25cwT1ac2rN29vsLS{padding:5px 15px;margin:0}", ""]);

// exports
exports.locals = {
	"toggle": "_1zB7H25cwT1ac2rN29vsLS"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"minimize":{"orderedValues":false}}!./node_modules/postcss-loader/lib?{"plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js!./obj/controls/header/owa-header-pane/lib/components/FeatureFlags/FeatureFlagsListItem.scss
// module id = 6205
// module chunks = 38